import {createContext, useCallback, useContext, useMemo, useState} from "react";

type CartDrawerCtx = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
};

const Ctx = createContext<CartDrawerCtx>({
  isOpen: false,
  open: () => {},
  close: () => {},
  toggle: () => {}
});

export function CartDrawerProvider({children}: {children: React.ReactNode}) {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const toggle = useCallback(() => setIsOpen((v) => !v), []);
  const value = useMemo(() => ({isOpen, open, close, toggle}), [isOpen, open, close, toggle]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useCartDrawer() {
  return useContext(Ctx);
}
